"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import classnames from "classnames";
import styles from "./Nav.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

const LINKS = [
  { path: "/", label: <FontAwesomeIcon icon={faHouse} /> },
  { path: "/premium-methodology", label: "Premium Methodology" },
  {
    path: "/help",
    label: "Help and Support",
    childLinks: [
      { path: "/help/faq", label: "FAQs" },
      // { path: "/help/premium-training", label: "Reconsideration" },
      { path: "/help/contact-premium", label: "Contact Premium" },
    ],
  },
];

const SECURE_LINKS = [
  { path: "/secure/dashboard", label: <FontAwesomeIcon icon={faHouse} /> },
  {
    path: "/secure/my-access",
    label: "My Access",
    childLinks: [
      { path: "/secure/my-access/my-groups", label: "My TINs" },
      { path: "/secure/my-access/my-delegates", label: "My Delegates" },
      { path: "/secure/my-access/my-physicians", label: "My Physicians" },
    ],
  },
  { path: "/premium-methodology", label: "Premium Methodology" },
  {
    path: "/help",
    label: "Help and Support",
    childLinks: [
      { path: "/help/faq", label: "FAQs" },
      // { path: "/help/premium-training", label: "Reconsideration" },
      { path: "/help/contact-premium", label: "Contact Premium" },
    ],
  },
];

interface NavProps {
  isAuthenticated: boolean;
  className?: string;
}

const Nav: React.FC<NavProps> = ({ isAuthenticated, className }) => {
  const links = isAuthenticated ? SECURE_LINKS : LINKS;
  const pathname = usePathname();

  return (
    <nav className={`${styles.nav}`}>
      <ul className={`${styles.nav}`}>
        {links.map((link) => (
          <li
            key={link.path}
            className={`${styles.nav__item} !font-semibold sm:text-sm`}
          >
            {link.childLinks ? (
              <div
                className={styles.dropdown}
                onMouseEnter={(e) => {
                  // Find the dropdown content within this dropdown container
                  const dropdownContent = (
                    e.currentTarget as HTMLElement
                  ).querySelector(`.${styles.dropdownContent}`);
                  // If it was hidden by our click handler, reset the style to allow CSS to take over again
                  if (
                    dropdownContent &&
                    (dropdownContent as HTMLElement).style.display === "none"
                  ) {
                    (dropdownContent as HTMLElement).style.display = "";
                  }
                }}
              >
                <button
                  className={classnames(
                    `${styles.nav__action} !font-semibold sm:text-sm`,
                    {
                      [styles.nav__action_active]: link.childLinks.some(
                        (child) => {
                          return pathname?.startsWith(child.path);
                        }
                      ),
                    }
                  )}
                >
                  {link.label} <FontAwesomeIcon icon="chevron-down" />
                </button>
                <ul className={styles.dropdownContent}>
                  {link.childLinks.map((childLink) => (
                    <li
                      key={childLink.label}
                      className={`${styles.dropdownMenu__item} !font-semibold sm:text-sm`}
                    >
                      <Link
                        href={childLink.path || "#"}
                        className={classnames(
                          `${styles.dropdownMenu__action} !font-semibold sm:text-sm`
                          // { [styles.nav__action_active]: childLink.path === pathname }
                        )}
                        onClick={(e) => {
                          // Find the parent dropdown menu
                          const dropdown = (
                            e.currentTarget as HTMLElement
                          ).closest(`.${styles.dropdownContent}`);
                          // Hide it before navigating
                          if (dropdown) {
                            (dropdown as HTMLElement).style.display = "none";
                          }
                        }}
                      >
                        {childLink.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <Link
                href={link.path || "#"}
                className={classnames(
                  `${styles.nav__action} !font-semibold sm:text-sm`,
                  {
                    [styles.nav__action_active]: pathname?.startsWith(
                      link.path
                    ),
                  }
                )}
              >
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
